import type { FC } from "react";
import type { ISharing } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";
import styled from "styled-components";
import { Button } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";

interface IFooter {
    onShare: VoidFunction;
    onCancel: VoidFunction;
    isLoading: boolean;
    sharing: ISharing;
    text?: string;
    hideCancelButton?: boolean;
}
const Container = styled.div`
    height: 56px;
    padding: 8px 24px;
    display: flex;
    gap: 8px;
    justify-content: end;
`;

export const Footer: FC<IFooter> = (props) => {
    const { onShare, isLoading, onCancel, sharing, text, hideCancelButton } = props;
    const { notification, sharingState, sharedWithUsers } = sharing;
    const { shouldNotify } = notification;
    const displayCancelButton = sharingState === ESharingState.SUBSET_OF_USERS && !hideCancelButton;
    const i18n = i18nFilter();
    const isNotifyActive = shouldNotify && sharingState === ESharingState.SUBSET_OF_USERS;
    const nonPrivateShareKey = isNotifyActive ? "asset.sharing.footer.share.notify" : "asset.sharing.footer.share";
    const shareKey = sharingState === ESharingState.PRIVATE ? "common.done" : nonPrivateShareKey;
    const isSubmitDisable =
        isLoading || (sharingState === ESharingState.SUBSET_OF_USERS && sharedWithUsers.length === 0);

    return (
        <Container>
            {displayCancelButton ? (
                <Button
                    type={"flat"}
                    onClick={onCancel}
                >
                    {i18n("asset.sharing.footer.cancel")}
                </Button>
            ) : null}
            <Button
                onClick={onShare}
                isLoading={isLoading}
                isDisabled={isSubmitDisable}
            >
                {i18n(text ?? shareKey)}
            </Button>
        </Container>
    );
};
